import React from 'react';
import ContentLoader from "react-content-loader";
import { PRODUCT_BULLION_TYPE, PRODUCT_GOLD_TYPE_NAME_INITIAL } from '../../../../constants';
import { useSelector } from 'react-redux';
import CurrencyFormat from '../../../../components/currencyFormat/currencyFormat';

export default function CompanyAccountDetails() {
    const { companyDashboard, isCompanyDashboardLoading, companyMetalAllocation } = useSelector((state) => state.companyDashboard);
    const { selectedCompany } = useSelector((state) => state.company);
    const { bidGoldHeader, bidSilverHeader } = useSelector((state) => state.user);


    function calculateTotals(bullionData, balanceData) {
        const getPrice = (item) => {
            if (item?.type === PRODUCT_GOLD_TYPE_NAME_INITIAL.KILOGRAM) {
                return item?.bullionType === PRODUCT_BULLION_TYPE.GOLD
                    ? parseFloat(bidGoldHeader?.gold1kg?.price)
                    : parseFloat(bidSilverHeader?.silver1kg?.price);
            }
            return item?.bullionType === PRODUCT_BULLION_TYPE.GOLD
                ? parseFloat(bidGoldHeader?.gold1g?.price)
                : parseFloat(bidSilverHeader?.silver10g?.price);
        };

        const totalAllocation = bullionData && bullionData?.length > 0 && bullionData.reduce((sum, item) => sum + (getPrice(item) * item?.quantity), 0);
        const totalBalance = balanceData && balanceData?.length > 0 && balanceData.reduce((sum, item) => sum + parseFloat(item.balance), 0);
        const grandTotal = totalAllocation + totalBalance;
        return parseFloat(grandTotal.toFixed(2));
    }

    return (
        <>
            <form>
                <div className='accountBorderSection BuillionAccountPadding'>
                    <div className='container-fluid p-0'>
                        <div className='row'>
                            <div className='col-md-3 col-6'>
                                <h6 className='accountPrimaryText'>Company account number</h6>
                                {isCompanyDashboardLoading ? (
                                    <div>
                                        <ContentLoader width="100%" height={15}>
                                            <rect x="0" y="0" rx="5" ry="5" width="100%" height="15" />
                                        </ContentLoader>
                                    </div>
                                ) : (
                                    <div className='accountSecondaryText accountSecondaryTextMargin'>{selectedCompany?.companyAccountNumber || 'XXXXXXXX-XXXXXX'}</div>
                                )}
                            </div>

                            <div className='col-md-3 col-6 rightAlignText'>
                                <h6 className='accountPrimaryText'>Total account balance</h6>
                                {isCompanyDashboardLoading ? (
                                    <div>
                                        <ContentLoader width="100%" height={15}>
                                            <rect x="0" y="0" rx="5" ry="5" width="100%" height="15" />
                                        </ContentLoader>
                                    </div>
                                ) : (
                                    <div className='accountSecondaryText accountSecondaryTextMargin'><CurrencyFormat value={calculateTotals(companyMetalAllocation, companyDashboard?.cashBalanceRecord)} decimal={2} /></div>
                                )}
                            </div>
                            <div className='col-md-6 col-0'></div>
                        </div>
                    </div>
                </div>
            </form >
        </>
    )
}
